import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { RATIO_OPTIONS, SHOT_OPTIONS } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import OptionCard from '../OptionCard';
import classNames from 'classnames';
import FJConfig from '../../../../../config/FJConfig';
import FJFileHandleUtil from '../../../../../util/FJFileHandleUtil';

import styles from './FJRatioSelector.module.less';
import commonStyles from './StepForm.module.less';

const FJRatioSelector = ({ selectedRatio, onRatioChange, selectedShot, onShotChange, gender }) => {
    // 根据性别过滤 shot 选项
    const shotOptionsList = useMemo(() => {
        return SHOT_OPTIONS.filter(option => option.gender === gender) ?? [];
    }, [gender]);

    return (
        <div className={commonStyles.step_form}>
            <h3 className={commonStyles.step_title}>{FJLocalStore._('shot-and-ratio')}</h3>

            {/* Shot Selection */}
            <div className={commonStyles.section}>
                <div className={commonStyles.options_grid}>
                    {shotOptionsList.map(shot => (
                        <OptionCard
                            key={shot.key}
                            title={FJLocalStore._(shot.key)}
                            imageUrl={FJFileHandleUtil.getImageUrlWithFormat(
                                `${FJConfig.headshotImagePath}${shot.imageUrl}?v=${FJConfig.version}`,
                            )}
                            isSelected={selectedShot.value === shot.value}
                            onClick={() => onShotChange(shot)}
                            imageAlt={FJLocalStore._(shot.value)}
                        />
                    ))}
                </div>
            </div>

            {/* Ratio Selection */}
            <div className={commonStyles.section}>
                <div className={styles.ratio_options}>
                    <div className={styles.ratio_options_title}>{FJLocalStore._('ratio')}</div>
                    {RATIO_OPTIONS.map(ratio => (
                        <div className={styles.option_card} key={ratio.key} onClick={() => onRatioChange(ratio)}>
                            <FJHoverBoardGradation
                                className={styles.hover_board_box}
                                contentClassName={styles.hover_board_content}
                                active={selectedRatio.value === ratio.value}
                                borderRadius={12}
                                selectBgColor='#ffffff'
                            >
                                <div className={styles.ratio_content}>
                                    <div className={styles.ratio_icon}>{ratio.icon ? <ratio.icon /> : null}</div>
                                    <span className={styles.ratio_text}>{ratio.value}</span>
                                    <div
                                        className={classNames(styles.selected_icon, {
                                            [styles.selected]: selectedRatio.value === ratio.value,
                                        })}
                                    >
                                        <div className={styles.selected_icon_inner} />
                                    </div>
                                </div>
                            </FJHoverBoardGradation>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

FJRatioSelector.propTypes = {
    selectedRatio: PropTypes.object,
    onRatioChange: PropTypes.func,
    selectedShot: PropTypes.object,
    onShotChange: PropTypes.func,
    gender: PropTypes.string,
};

export default FJRatioSelector;
